'use strict';
const topbanners = document.getElementsByClassName('js-top-banner__slideshow');

for (var i = 0; i < topbanners.length; i++) {
    new Vue({
        el: topbanners[i],
        name: 'top-banner',
        data: {
            autoPlayMilliSeconds:7000,
            inViewport: false,
            addClassForSlideHeight: false,
            sliderElement:null,
            flkty: null,
            videosInSlider: [],
            slidesCount: 0
        },
        mounted() {
            this.sliderElement = this.$refs.slideshowList;
            if(!this.sliderElement){return;}
            
            this.slidesCount = this.sliderElement.children.length;
            const videoNodesInSlider = this.sliderElement.getElementsByClassName('top-banner__video');
            this.videosInSlider = Array.prototype.slice.call(videoNodesInSlider);
            this.observeVideoSliderInViewport();
            this.initSlider();
            this.resizeSlider();
        },
        methods: {
            observeVideoSliderInViewport(){
                const options = { threshold: 0 };
                const backgroundObserver = new IntersectionObserver(this.sliderIsInViewPort, options);
                backgroundObserver.observe(this.$el);
            },
            sliderIsInViewPort(entries){
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.inViewport = true;
                        this.videosInSlider.forEach(
                            (videoEl)=>{
                                const videoSrc = videoEl.getAttribute('data-html');
                                videoEl.innerHTML = videoSrc;
                            }
                        );
                        this.flkty.selectCell( 0, false, true ); // to trigger start of video on first slide
                    }
                    else {
                        this.inViewport = false;
                        this.videosInSlider.forEach(
                            (videoEl)=>{
                                videoEl.innerHTML = '';
                            }
                        );
                    }
                });
            },
            playVideo(currentSlide){
                if(this.inViewport && currentSlide.classList.contains('top-banner__item--has-video')) {
                    const currentVideo = currentSlide.getElementsByClassName('top-banner__video')[0] || null;
                    if(!currentVideo){
                        this.stopVideosInThisSlider();
                        return;
                    }
                    if(this.slidesCount > 1){
                        this.stopVideosInThisSlider();
                        currentVideo.currentTime = 0;
                    }
                    currentVideo.play();
                }
            },
            stopVideosInThisSlider() {
                const videosInSlider = this.sliderElement.getElementsByClassName('top-banner__video');
                for(let i = 0; i < videosInSlider.length; i++) {
                    videosInSlider[i].pause();
                }
            },
            initSlider(){
                const self = this;
                const pageDots = this.slidesCount > 1;
                this.flkty = new Flickity( this.sliderElement, {
                    wrapAround: true,
                    autoPlay: this.slidesCount > 1 ? this.autoPlayMilliSeconds : false,
                    pauseAutoPlayOnHover: false,
                    prevNextButtons: false,
                    pageDots: pageDots,
                    on: {
                        ready: function(e) {
                            self.addClassForSlideHeight=true;
                            if(this && this.selectedCell){
                                self.playVideo(this.selectedCell.element);
                            }
                        },
                        select: function(e) {
                            if(this && this.selectedCell){
                                self.playVideo(this.selectedCell.element);
                            }
                        }
                    }
                });
            },
            resizeSlider(){
                const self = this;
                window.addEventListener('resize',function(){
                    self.addClassForSlideHeight=false;
                    this.setTimeout(function(){
                        self.addClassForSlideHeight=true;
                    });
                });
            }
        }
    });
}
